import {TableHeaderItem} from "@/views/components/YtoTable/TableHeaderItem";

// const defaultWidth = 120;

const pintedResultTableHeader: TableHeaderItem[] = [
  {prop: "index", label: "序号", width: null},
  {prop: "packageName", label: "包名称", width: null},
  {prop: "packageType", label: "拆包组织名称", width: null},
  {prop: "waybillNo", label: "建包类型", width: null},
  {prop: "ext1", label: "打印数量", width: null}
];

const searchResultTableHeader: TableHeaderItem[] = [
  {prop: "DestOrgCode", label: "目的地代码", width: null},
  {prop: "DestOrgName", label: "目的地名称", width: null},
  {prop: "PrintKeyWord", label: "自定义名称", width: null},
  {prop: "ThreeCode", label: "网点/业务员三段码", width: null},
  {prop: "SubdivisionCode", label: "自定义分拣码", width: 120},
  {prop: "PrePrintTotal", label: "预打印数量", width: 120},
  {prop: "PrintedCount", label: "已打印数量", width: 120},
  {prop: "FailedCount", label: "失败数量", width: 120},
];

export default {pintedResultTableHeader, searchResultTableHeader};
